import { VerticalStack } from "@mallardbay/lib-react-components"
import React from "react"

import AvatarAndInfo from "~components/shared/avatar-and-info"
import { TEST_IDS } from "~config/test-ids"
import type {
    OutfitterMinimalFieldsFragment,
    PublicOutfitterFieldsFragment,
} from "~graphql/generated/graphql"
import useOwnersAndCoOwners from "~utils/use-owners-and-co-owners"
import { formatEnumToTitleCase } from "~utils/formatting-helpers"

import Spinner from "../spinner"

interface Props {
    readonly outfitter:
        | PublicOutfitterFieldsFragment
        | OutfitterMinimalFieldsFragment
}

export default function OwnerSection({ outfitter }: Props) {
    const { allOwners, isLoading } = useOwnersAndCoOwners({
        outfitterId: outfitter.id,
    })

    if (isLoading) {
        return <Spinner />
    }

    return (
        <VerticalStack>
            {allOwners.map((owner) => {
                return (
                    <AvatarAndInfo
                        key={owner.id}
                        avatar={owner.avatar ?? ""}
                        name={owner.name}
                        title={owner.name}
                        subtitle={formatEnumToTitleCase(owner.role)}
                        testId={TEST_IDS.OWNER_SECTION}
                    />
                )
            })}
        </VerticalStack>
    )
}
